import React, { useContext } from 'react';
import { Formik, Form } from 'formik';
import PropTypes from 'prop-types';
import * as Yup from 'yup';
import Redactor from '../../../../../_shared-react/redactor.min.js';

import PropertyFormFields, { propertyValidationSchema } from '../../_molecules/PropertyFormFields';
import GlobalModal from '@molecules/GlobalModal/index';
import { GlobalModalContext } from '@context/globalModalContext';

export const useNewPropertyModal = () => {
    const [, setIsModalOpen, setModalChildren] = useContext(GlobalModalContext);

    const openModal = onCreatePropertySuccess => {
        setIsModalOpen(true);
        setModalChildren(
            NewPropertyModal({
                closeModal: () => setIsModalOpen(false),
                onCreatePropertySuccess,
            })
        );
    };

    return { openModal };
};

const NewPropertyModal = ({ onCreatePropertySuccess }) => {
    const onSubmit = () => {
        // Only needed to show validation errors.
    };

    const onReset = () => {
        Redactor('.redactor[name=description]', 'source.setCode', '');
        document.getElementsByClassName('ReactModal__Form')[0].scrollIntoView(true);
    };

    const initialValues = {
        title: '',
        location: '',
        subpremiseId: '',
        url: '',
        listingStatus: '',
        size: '',
        purpose: '',
        density: '',
        typeOfCenter: '',
        typeOfFacility: '',
        description: '',
    };

    return (
        <GlobalModal modalInnerClass="ReactModal__Form">
            <>
                <h3 id="formTitle" className="mb-4">
                    New Property
                </h3>

                <Formik
                    onSubmit={onSubmit}
                    onReset={onReset}
                    enableReinitialize
                    initialValues={initialValues}
                    validationSchema={Yup.object(propertyValidationSchema)}
                >
                    <Form noValidate style={{ display: 'flex', flexDirection: 'column' }}>
                        <PropertyFormFields onCreatePropertySuccess={onCreatePropertySuccess} />
                    </Form>
                </Formik>
            </>
        </GlobalModal>
    );
};

NewPropertyModal.propTypes = {
    onCreatePropertySuccess: PropTypes.func,
};

export default NewPropertyModal;
